// src/components/Event.js
import React, { useEffect, useState } from 'react';
import styles from '../App.module.css';

const Event = () => {
  const [event, setEvent] = useState([]);
  const [loading, setLoading] = useState(true);
  const baseurl = process.env.REACT_APP_API_BASE_URL;
  const fetchEvents = async() => {
    try {
      const response = await fetch(`${baseurl}get-all-event.php`);
      const result = await response.json();
      setEvent(result.data); // Adjust based on your API response   
      setLoading(false)     
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false)
    } finally {}
  };
  useEffect(()=>{
    fetchEvents()
  },[])
  return (
    <>
    {
      loading ? (
        <div className="animate-pulse bg-slate-500 w-full">
          <div className="flex justify-between p-0 py-4 h-full container">
              <div className="h-72 w-1/4 mx-2 bg-slate-500 pt-3">
                <div className="h-10 bg-gray-200 rounded dark:bg-slate-400 w-60 mb-2"></div>
                <div className="h-2.5 bg-gray-200 rounded dark:bg-slate-400 w-60 mb-2"></div>
                <div className="h-2.5 bg-gray-200 rounded dark:bg-slate-400 w-52 mb-2"></div>
                <div className="h-8 bg-gray-200 dark:bg-slate-400 w-24 mb-2"></div>
              </div>
              <div class='w-3/4 grid grid-cols-2 gap-4'>
                <div>
                  <div className="h-56 rounded bg-slate-300 mb-3"></div>
                  <div className="h-3.5 bg-gray-200 rounded dark:bg-slate-400 w-28 mb-2"></div>
                  <div className="h-6 bg-gray-200 rounded dark:bg-slate-400 w-3/4 mb-2"></div>
                  <div className="h-2.5 bg-gray-200 rounded dark:bg-slate-400 w-5/6"></div>
                </div>
                <div>
                  <div className="h-56 rounded bg-slate-300 mb-3"></div>
                  <div className="h-3.5 bg-gray-200 rounded dark:bg-slate-400 w-28 mb-2"></div>
                  <div className="h-6 bg-gray-200 rounded dark:bg-slate-400 w-3/4 mb-2"></div>
                  <div className="h-2.5 bg-gray-200 rounded dark:bg-slate-400 w-5/6"></div>
                </div>
                <div>
                  <div className="h-56 rounded bg-slate-300 mb-3"></div>
                  <div className="h-3.5 bg-gray-200 rounded dark:bg-slate-400 w-28 mb-2"></div>
                  <div className="h-6 bg-gray-200 rounded dark:bg-slate-400 w-3/4 mb-2"></div>
                  <div className="h-2.5 bg-gray-200 rounded dark:bg-slate-400 w-5/6"></div>
                </div>
                <div>
                  <div className="h-56 rounded bg-slate-300 mb-3"></div>
                  <div className="h-3.5 bg-gray-200 rounded dark:bg-slate-400 w-28 mb-2"></div>
                  <div className="h-6 bg-gray-200 rounded dark:bg-slate-400 w-3/4 mb-2"></div>
                  <div className="h-2.5 bg-gray-200 rounded dark:bg-slate-400 w-5/6"></div>
                </div>                
              </div>
            </div>
        </div>
      ):(
        <section id="event" className="py-10 pb-20 bg-dark">
          <div className="container">
            <div className="row">
              <div className="col-md-3">
                <h2 className="text-5xl font-bold uppercase text-white">Event</h2>
                <p className='text-white text-xs mb-0'>We are nationally recognized event planning & organising company based in mumbai.</p>
                <button className="text-xs mt-6 p-2 px-3 uppercase border-yellow-400 border-1 text-black hover:text-white font-semibold hover:bg-transparent bg-yellow-400 transition duration-300">View all</button>
              </div>
              <div className="col-md-9" data-aos="fade-left">
                <div className="row">
                  {
                    event.map((event, index)=>{
                      if(index < 4)
                        return <div className="col-md-6 mb-2" key={index}>
                          <div className={`${styles.event_cards}`}>
                            <img loading="lazy" src={event.image} alt={event.title} className={`${styles.event_image} mb-2`} />
                            <p className='text-yellow-400 mb-0  font-semibold'>{event.add_date}</p>
                            <h3 className="text-xl font-bold mb-1 text-white uppercase">{event.title}</h3>
                            <p className="text-white font-semibold">{event.sub_title}</p>
                          </div>          
                        </div>
                    })
                  }              
                </div>
              </div>
            </div>
          </div>
        </section>
      )
    }
    </>
  );
}

export default Event;
